module.exports = __webpack_public_path__ + "img/whispers_of_wood-hero.984655a.webp";